import { render, staticRenderFns } from "./OntProfileConfig.vue?vue&type=template&id=740a3195&"
import script from "./OntProfileConfig.vue?vue&type=script&lang=js&"
export * from "./OntProfileConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports